function mix32(value: number): number {
  let x = value >>> 0;
  x ^= x >>> 16;
  x = Math.imul(x, 0x7feb352d);
  x ^= x >>> 15;
  x = Math.imul(x, 0x846ca68b);
  x ^= x >>> 16;
  return x >>> 0;
}

export function hashChoice(seed: number, chamberIndex: number, streamId: number): number {
  const chamber = Math.imul(chamberIndex + 1, 0x9e3779b1);
  const stream = Math.imul(streamId + 1, 0x85ebca77);
  return mix32((seed >>> 0) ^ chamber ^ stream);
}

export function choice(seed: number, chamberIndex: number, streamId: number, count: number): number {
  if (!Number.isInteger(count) || count <= 0) {
    throw new RangeError("choice count must be a positive integer");
  }
  return hashChoice(seed, chamberIndex, streamId) % count;
}

export const MAIN_TIMELINE_SEED = 0x5eedc0de;

export function randomSeed(): number {
  const value = new Uint32Array(1);
  globalThis.crypto.getRandomValues(value);
  return value[0]!;
}
